<div class="tw-bg-[#FFD748] tw-flex tw-justify-center tw-mb-3 tw-rounded-md tw-py-2 tw-px-16">
    <div [innerHtml]="('voices.alert_beta' | translate:{'url': url})"></div>
</div>
